<header class="header">
    <div class="container">
        <ins-topbar-container [useAngularRouter]="useAngularRouter"></ins-topbar-container>
        <ins-navigation [useAngularRouter]="useAngularRouter"></ins-navigation>
    </div>
</header>
